import { ValueOf } from '../utilities/types';

const entityTypes = {
  INDIVIDUAL: 'Individual',
  BUSINESS: 'Business',
  CAR: 'Car',
  ACCOUNT: 'Account',
  PRODUCT: 'Product',
  UNKNOWN: 'Unknown',
} as const;

export const entityTypesFromResource: Record<string, EntityTypes> = {
  individuals: entityTypes.INDIVIDUAL,
  businesses: entityTypes.BUSINESS,
  cars: entityTypes.CAR,
  'account-entities': entityTypes.ACCOUNT,
  products: entityTypes.PRODUCT,
};

export type EntityTypes = ValueOf<typeof entityTypes>;
export type KnownEntityTypes = Exclude<EntityTypes, typeof entityTypes.UNKNOWN>;

export const resourceFromEntityTypes: Record<KnownEntityTypes, string> = {
  [entityTypes.INDIVIDUAL]: 'individuals',
  [entityTypes.BUSINESS]: 'businesses',
  [entityTypes.CAR]: 'cars',
  [entityTypes.ACCOUNT]: 'account-entities',
  [entityTypes.PRODUCT]: 'products',
};

export const entityTypesChoices = Object.values(entityTypes).map((type) => ({
  id: type,
  name: type,
}));

export const knownEntityTypesChoices = entityTypesChoices
  .filter(({ id }) => id !== entityTypes.UNKNOWN);

export const isValidEntityType = (value: string): value is EntityTypes => (
  Object.values(entityTypes) as string[]
).includes(value);

export default entityTypes;
